/**
 * Per-tab client id.
 *
 * Sent as the X-Client-Id header on every API request and echoed back by the
 * backend on websocket broadcasts (WebSocketAppointmentDto.clientId). The
 * SocketHandler uses it to ignore broadcasts for changes this tab initiated
 * itself — those are already reflected in the cache via the mutation's
 * onMutate/onSuccess handlers.
 *
 * Module scope = one id per tab/window (each tab evaluates its own modules).
 */
export const CLIENT_ID: string =
  typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;

export const CLIENT_ID_HEADER = "X-Client-Id";
